import classNames from 'classnames';

import Typography from '../../core/Typography';
import StepWithDescription from '../base/StepWithDescription';
import HowToSchema from '../HowToSchema';

import useStyles from './styles';
import ISimplifiedStepSection from './types';

function SimplifiedStepSection({
  title,
  label,
  steps,
  cta,
  className,
  stepsClassName,
  headingElement = 'h2',
  labelElement = 'h3',
  stepHeadingElement = 'h3',
}: ISimplifiedStepSection) {
  const classes = useStyles();

  if (process.env.NODE_ENV !== 'production') {
    const hasInvalidStep = steps.some(({ description }) => typeof description !== 'string');
    if (hasInvalidStep) {
      console.warn(
        '[SimplifiedStepSection] At least one step has a non-string `description`; HowTo schema falls back per-step. Section still renders.',
      );
    }
  }

  return (
    <section className={classNames(classes.container, className, 'landing-banner')}>
      <div className={classes.root}>
        {label && (
          <Typography className={classes.label} element={labelElement} look="p">
            {label}
          </Typography>
        )}

        <Typography className={classes.title} element={headingElement}>
          {title}
        </Typography>

        <div className={classNames(classes.steps, stepsClassName)}>
          {steps.map((step, index) => (
            <StepWithDescription
              key={index}
              headingElement={stepHeadingElement}
              index={index + 1}
              title={step.title}
              description={step.description}
            />
          ))}
        </div>

        <div className={classes.actions}>{cta}</div>
      </div>

      <HowToSchema
        title={title}
        label={label}
        steps={steps.map((step) => ({
          title: step.title,
          description: step.description,
        }))}
      />
    </section>
  );
}

export default SimplifiedStepSection;
